import React from 'react';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@ais-ui/ui-core';
import { PiDotsThreeVertical } from 'react-icons/pi';
import { useLocalization } from '@ais-ui/locale-management';
import { ReportTemplate } from '@ais-ui/websockets';

interface ReportTemplateDropDownMenuProps {
  reportTemplate: ReportTemplate;
  onDelete: () => void;
  onSchedule: () => void;
  onDeleteSchedule: () => void;
  isScheduled: boolean;
  className?: string;
}

export const ReportTemplateDropDownMenu = ({
  reportTemplate,
  onDelete,
  onSchedule,
  onDeleteSchedule,
  isScheduled,
  className,
}: ReportTemplateDropDownMenuProps) => {
  const { messages } = useLocalization();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild className={className}>
        <Button
          id={`${reportTemplate.tplName}-dropdown-button`}
          size="icon"
          variant="ghost"
          className="h-8 w-8"
        >
          <PiDotsThreeVertical className="h-6 w-6" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {isScheduled && (
          <DropdownMenuItem onClick={onDeleteSchedule}>
            Delete schedule
          </DropdownMenuItem>
        )}
        {!isScheduled && (
          <DropdownMenuItem onClick={onSchedule}>Schedule</DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={onDelete}>
          {messages.genericDelete}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
